module.exports = __webpack_public_path__ + "static/img/authorized.49f5460f.png";